export const getHoverStyles = (color, backgroundColor) => {
    // Lighten or darken logic based on backgroundColor
    const lightenDarkenColor = (col, amt) => {
        let usePound = false;
        if (col[0] === "#") {
            col = col.slice(1);
            usePound = true;
        }

        let num = parseInt(col, 16);
        let r = (num >> 16) + amt;
        let b = ((num >> 8) & 0x00FF) + amt;
        let g = (num & 0x0000FF) + amt;

        r = Math.min(255, Math.max(0, r));
        b = Math.min(255, Math.max(0, b));
        g = Math.min(255, Math.max(0, g));

        return (usePound ? "#" : "") + ((1 << 24) + (r << 16) + (b << 8) + g).toString(16).slice(1);
    };

    return {
        hoverBackground: lightenDarkenColor(backgroundColor || "#000000", -20),
        hoverColor: lightenDarkenColor(color || "#ffffff", 20)
    };
}